import React from "react";
import Ticker from "./Ticker";

function parseTickers(value) {
  if (Array.isArray(value)) {
    return value;
  }

  if (typeof value !== "string") {
    return [];
  }

  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
}

export default function TickerTape({
  title = "Market pulse",
  subtitle = "Prices and field signals loop across the home page.",
  tickers = [],
  items = [],
  duration = 48,
  className = "",
  ariaLabel = ""
}) {
  const sourceTickers = parseTickers(tickers).length ? parseTickers(tickers) : parseTickers(items);

  if (!sourceTickers.length) {
    return null;
  }

  const tapeClasses = ["sh-ticker-tape", className].filter(Boolean).join(" ");
  const repeatedTickers = [...sourceTickers, ...sourceTickers];
  const trackStyle = { "--ticker-duration": `${duration}s` };
  const label = ariaLabel || `${title} ticker tape`;

  return (
    <section className={tapeClasses} aria-label={label} aria-live="off">
      <div className="sh-ticker-tape-shell">
        {/* <div className="sh-ticker-tape-header"> */}
          {/* <div className="sh-ticker-tape-copy"> */}
            {/* <span className="sh-ticker-tape-kicker">{title}</span> */}
            {/* {subtitle ? <span className="sh-ticker-tape-subtitle">{subtitle}</span> : null} */}
          {/* </div> */}
          {/* <span className="sh-ticker-tape-indicator">
            <i className="bi bi-lightning-charge-fill me-2" aria-hidden="true" />
            Live loop
          </span> */}
        {/* </div> */}

        <div className="sh-ticker-viewport">
          <div className="sh-ticker-track" style={trackStyle}>
            <div className="sh-ticker-group">
              {sourceTickers.map((ticker, index) => (
                <Ticker
                  key={ticker.id || `${ticker.title || "ticker"}-${index}`}
                  {...ticker}
                />
              ))}
            </div>

            <div className="sh-ticker-group" aria-hidden="true">
              {repeatedTickers.map((ticker, index) => (
                <Ticker
                  key={`${ticker.id || ticker.title || "ticker"}-${index}-clone`}
                  {...ticker}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}